import type { CalloutBlock } from "../../../services/educationService";
import styles from "./article.module.css";

// Figma node 2340:39963 — bullet ("Points") callouts get an info-circle icon
// to the left of the title.
const IconTips = () => (
	<svg
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none"
		aria-hidden="true"
	>
		<path
			fill="#5e60bf"
			d="M0 9.99939C0 4.47688 4.47688 0 9.99939 0C15.5219 0 19.9988 4.47688 19.9988 9.99939C19.9988 15.5219 15.5219 19.9988 9.99939 19.9988C4.47688 19.9988 0 15.5219 0 9.99939Z"
		/>
		<path
			fill="#fff"
			d="M9.99494 5.00244C7.23666 5.00244 4.99805 7.24105 4.99805 9.99934C4.99805 12.7576 7.23666 14.9962 9.99494 14.9962C12.7532 14.9962 14.9918 12.7576 14.9918 9.99934C14.9918 7.24105 12.7532 5.00244 9.99494 5.00244ZM10.4946 12.4978H9.49525V11.4984H10.4946V12.4978ZM10.4946 10.499H9.49525V7.50089H10.4946V10.499Z"
		/>
	</svg>
);

export function ArticleCallout({ block }: { block: CalloutBlock }) {
	const hasItems = !!block.items && block.items.length > 0;
	return (
		<aside className={styles.callout}>
			{block.title && (
				<div className={styles.calloutTitleRow}>
					{hasItems && <IconTips />}
					<h4 className={styles.calloutTitle}>{block.title}</h4>
				</div>
			)}
			{block.body && <p className={styles.calloutBody}>{block.body}</p>}
			{hasItems && (
				<ul className={styles.calloutItems}>
					{block.items?.map((it, i) => (
						<li key={i}>{it}</li>
					))}
				</ul>
			)}
		</aside>
	);
}
